const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  course: yup.string().required("Course is required"),
  staff: yup.string().required("Staff is required"),
});

module.exports = {
  create,
};
